import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instance22ozgv6vdnc2g as EmptyIterator_instance } from './CollectionsKt.mjs';
import {
  iterator3f5i676wpaa3g as iterator,
  SequenceScope1coiso86pqzq2 as SequenceScope,
} from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance23tt71mgnug0i as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda_0(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.tl_1 = this$0;
        super($box);
        this.rl_1 = this$0.xl_1;
        this.sl_1 = this$0.wl_1;
      }
      ni() {
        if (this.rl_1 === 0) {
          this.pi();
        } else {
          this.oi(this.tl_1.ul_1[this.sl_1]);
          var tmp = this;
          var tmp0 = this.tl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.sl_1 = (this.sl_1 + 1 | 0) % tmp0.vl_1 | 0;
          this.rl_1 = this.rl_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      static yl(buffer, filledSize) {
        var $this = this.ui();
        $this.ul_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.ul_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.ul_1.length;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        $this.vl_1 = $this.ul_1.length;
        $this.wl_1 = 0;
        $this.xl_1 = filledSize;
        return $this;
      }
      static zl(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.yl(tmp$ret$0, 0);
      }
      q2() {
        return this.xl_1;
      }
      r2(index) {
        Companion_instance.i7(index, this.xl_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.wl_1 + index | 0) % this.vl_1 | 0;
        return this.ul_1[tmp$ret$0];
      }
      am() {
        return this.xl_1 === this.vl_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      tj(array) {
        var tmp;
        if (array.length < this.xl_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.xl_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.xl_1;
        var widx = 0;
        var idx = this.wl_1;
        while (widx < size && idx < this.vl_1) {
          result[widx] = this.ul_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.ul_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.xl_1;
        var tmp$ret$0 = Array(size);
        return this.tj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      bm(maxCapacity) {
        var newCapacity = coerceAtMost((this.vl_1 + (this.vl_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.wl_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.ul_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.tj(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().yl(newBuffer, this.xl_1);
      }
      cm(element) {
        if (this.am()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.wl_1 + this.xl_1 | 0) % this.vl_1 | 0;
        this.ul_1[tmp$ret$0] = element;
        this.xl_1 = this.xl_1 + 1 | 0;
      }
      dm(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.xl_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.xl_1;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        if (n > 0) {
          var start = this.wl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.vl_1 | 0;
          if (start > end) {
            fill(this.ul_1, null, start, this.vl_1);
            fill(this.ul_1, null, 0, end);
          } else {
            fill(this.ul_1, null, start, end);
          }
          this.wl_1 = end;
          this.xl_1 = this.xl_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
var windowedIterator$slambdaClass;
function windowedIterator$slambda() {
  if (windowedIterator$slambdaClass === VOID) {
    class $ {
      constructor($size, $step, $iterator, $reuseBuffer, $partialWindows) {
        this.em_1 = $size;
        this.fm_1 = $step;
        this.gm_1 = $iterator;
        this.hm_1 = $reuseBuffer;
        this.im_1 = $partialWindows;
      }
      *jm($this$iterator, $completion) {
        var bufferInitialCapacity = coerceAtMost(this.em_1, 1024);
        var gap = this.fm_1 - this.em_1 | 0;
        if (gap >= 0) {
          var buffer = ArrayList().h2(bufferInitialCapacity);
          var skip = 0;
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = this.gm_1;
          $l$loop: while (_iterator__ex2g4s.q1()) {
            var e = _iterator__ex2g4s.r1();
            if (skip > 0) {
              skip = skip - 1 | 0;
              continue $l$loop;
            }
            buffer.i2(e);
            if (buffer.q2() === this.em_1) {
              yield* $this$iterator.yk(buffer, $completion);
              if (this.hm_1) {
                buffer.a5();
              } else
                buffer = ArrayList().h2(this.em_1);
              skip = gap;
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!buffer.n1()) {
            if (this.im_1 || buffer.q2() === this.em_1)
              yield* $this$iterator.yk(buffer, $completion);
          }
        } else {
          var buffer_0 = RingBuffer().zl(bufferInitialCapacity);
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s_0 = this.gm_1;
          $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
            var e_0 = _iterator__ex2g4s_0.r1();
            buffer_0.cm(e_0);
            if (buffer_0.am()) {
              if (buffer_0.xl_1 < this.em_1) {
                buffer_0 = buffer_0.bm(this.em_1);
                continue $l$loop_0;
              }
              yield* $this$iterator.yk(this.hm_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.dm(this.fm_1);
            }
          }
          if (this.im_1) {
            while (buffer_0.xl_1 > this.fm_1) {
              yield* $this$iterator.yk(this.hm_1 ? buffer_0 : ArrayList().j2(buffer_0), $completion);
              buffer_0.dm(this.fm_1);
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!buffer_0.n1())
              yield* $this$iterator.yk(buffer_0, $completion);
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.jm(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    windowedIterator$slambdaClass = $;
  }
  return windowedIterator$slambdaClass;
}
function windowedIterator$slambda_0($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  var i = new (windowedIterator$slambda())($size, $step, $iterator, $reuseBuffer, $partialWindows);
  var l = ($this$iterator, $completion) => i.jm($this$iterator, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
